import Datepicker from 'vuejs-datepicker';
import lang from "@/views/modules/Applications/language/en";
import alert from "@/views/shared/notify/Alert.vue";


export default {
    name: "new-application",
 
    components: {
        Datepicker,
        alert
        // 'editor': Editor,
    },
    data() {
        return {
            loading: true,
            formData:{
                application_title:'',
                application_date:''
            },
            strategic_priority:[],
            dataList:[],
            lang:[],
            dateFormat:'',
            dom_array: [],
            opportunity_data:{},
            process:false,
            disabled:false,
        }
    },
    mounted() {
        this.lang = lang;
        this.formData = {
            parent_type:'opportunitys',
            opportunity_id:this.$route.query.opportunity_id,
            'application_title':'',
        }
        document.getElementById("opportunity_title").value=this.$route.query.titile;
      
        this.dom_array = this.domArrayVariable;
        let current_date = localStorage.getItem('current_date');
        let date_arr = current_date.split(" ");
        this.formData.application_date = this.$date.parse(date_arr[0]);
     
      this.getOpportunity();
    },
    methods: {
        SaveApplication(){
            const self = this;
                
               if(self.formData.application_title !=''){
                    self.process = true;
                    self.formData.strategic_priority = self.strategic_priority;
                   
                  axios.post('api/modules/applications', self.formData).then(function(res){
                        if(res.data.message !=''){
                            self.process = false;
                            self.$router.push(`/modules/applications`);
                        }
                    }).catch(function (error) {
                        self.loading = false;
                        self.process = false;
                        let allerror = document.getElementsByClassName('error');
                        for(let i = 0; i < allerror.length; i++)
                        {
                            allerror[i].innerHTML = '';
                        }
                        let err = localStorage.getItem('Errors');
                        let err_msg = (JSON.parse(err));
                        let err_msg2 = err_msg && err_msg.errors ? err_msg.errors : {};
                        Object.keys(err_msg2 || {}).forEach((key) => {
                            let errorval = err_msg2[key];
                           
                            let error_el = document.getElementById(key+"_error");
                                error_el.innerHTML = errorval
                        });
                        localStorage.removeItem('Errors');
                    });
                }else{
                   self.$refs.notifyMsg.showAlert('Error', 'Please Enter Application Title');
                }
              
        },
        customFormatter(date) {
            return moment(date).format('DD/MM/yyyy');
        },

        getOpportunity(){
            const self = this;
            let opp_date = {'opp_id':self.$route.query.opportunity_id};
             axios.post('api/modules/applications/getopportunity', opp_date).then(function (response) {
                 if(response.data.message == ''){
                    self.opportunity_data = response.data;
                 }else{
                   
                   self.$refs.notifyMsg.showAlert('Error', response.data.message);
                   self.$router.push(`/modules/applications`);
                 }
                
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            }); 
        }
       
    }
}